import { EngagementProcessStatus } from '../../timeline/models/enums/engagement-process-status.enum';
import { TimelineState } from '../../timeline/models/enums/timeline-state.enum';

// [#1304] Meetings are paused from the suspension until the catch-up reaches the Seller's timeline: all that time the
// Seller's timeline - and a Current Buyer's with it - is frozen. The API refuses every meeting action then with this
// message (MeetingsPause); the screens say it too, instead of a generic error.
export const MEETINGS_PAUSED_MESSAGE =
    'Meetings are paused while the engagement is suspended, and until it has caught up after the resume.';

export const areMeetingsPaused = (timeline?: {
    state?: TimelineState;
    engagementProcess?: { status?: EngagementProcessStatus };
}): boolean =>
    timeline?.state === TimelineState.SUSPENDED ||
    timeline?.engagementProcess?.status === EngagementProcessStatus.Suspended;

export const meetingsPausedMessageOf = (error: any): string | null => {
    const data = error?.response?.data ?? error?.responseData;
    const serverMessage = data?.message || data?.detail || data?.title;
    return serverMessage === MEETINGS_PAUSED_MESSAGE ? serverMessage : null;
};
